import { EnvironmentInjector, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StaticInjectorService {
  public static injector: EnvironmentInjector;

  public static set envInjector(injector: EnvironmentInjector) {
    StaticInjectorService.injector = injector;
  }
}
